export type CapabilityUser = {
  is_global_admin?: boolean;
  capabilities?: string[];
  site_permission?: {
    open_state?: string | null;
  } | null;
} | null | undefined;

export const hasCapability = (user: CapabilityUser, capability: string): boolean => {
  if (!capability) {
    return Boolean(user?.is_global_admin);
  }

  if (user?.is_global_admin) {
    return true;
  }

  const capabilities = Array.isArray(user?.capabilities) ? user.capabilities : [];
  return capabilities.includes(capability);
};

export const canManageSiteScopedCommerce = (user: CapabilityUser): boolean => {
  return hasCapability(user, "site_owner");
};

export const isSitePaused = (user: CapabilityUser): boolean => {
  return !user?.is_global_admin && user?.site_permission?.open_state === "pause";
};

export const hasPausedSiteContext = (user: CapabilityUser): boolean => {
  return user?.site_permission?.open_state === "pause";
};
